// extracted by mini-css-extract-plugin
export default {"container":"CheckoutLines_container__EJ5vJ","text":"CheckoutLines_text__HUZvx"};